// Core imports
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Component imports
import { Alert, Button, Card, Form, Input, Typography } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import SEO from '../components/SEO/SEO';

// Misc imports
import { blogLogin } from '../store/blog/blogThunks';
import { NAV_BLOG_EDITOR_NEW } from '../constants';

const { Title, Paragraph } = Typography;

const BlogLoginScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, author } = useSelector(state => state.blogAuth);
  const [error, setError] = useState(null);

  // Already logged in, use <Navigate> to avoid setState-during-render
  if (author) {
    return <Navigate to={NAV_BLOG_EDITOR_NEW} replace />;
  }

  const onFinish = async ({ email, password }) => {
    setError(null);
    try {
      await dispatch(blogLogin(email, password));
      navigate(NAV_BLOG_EDITOR_NEW);
    } catch (err) {
      setError(err?.description || 'Invalid email or password.');
    }
  };

  return (
    <>
      <SEO title="Author Login | Blog" noIndex />

      <div className="blog-login-page">
        <Card className="blog-login-card" bordered={false}>
          <Title level={3} style={{ marginBottom: 4 }}>Author Login</Title>
          <Paragraph className="text-color-black-60 mb-24">
            Sign in to create or manage blog posts.
          </Paragraph>

          {error && (
            <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />
          )}

          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' }
              ]}
            >
              <Input prefix={<MailOutlined />} size="large" placeholder="ndearchive@gmail.com" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password prefix={<LockOutlined />} size="large" placeholder="Password" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={isLoading}
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default BlogLoginScreen;
